import { Translation } from '../types';

export const nl: Translation = {
  common: {
    loading: 'Laden...',
    error: 'Fout',
    cancel: 'Annuleren',
    save: 'Opslaan',
    close: 'Sluiten',
    search: 'Zoeken',
    reload: 'Vernieuwen',
    logout: 'Uitloggen',
    dashboard: 'Dashboard',
    products: 'Producten',
    settings: 'Instellingen',
    language: 'Taal',
    businessHours: 'Openingstijden',
    back: 'Terug',
    selectAll: 'Alles selecteren',
    deselectAll: 'Alles deselecteren',
    success: 'Succes',
    selected: 'Geselecteerd',
    confirm: 'Bevestigen',
    required: 'Verplicht',
    requiredMarker: '*',
    previous: 'Vorige',
    next: 'Volgende',
    allRightsReserved: 'Alle rechten voorbehouden.',
  },
  auth: {
    login: 'Inloggen',
    email: 'E-mailadres',
    password: 'Wachtwoord',
    loginButton: 'Inloggen',
    loggingIn: 'Bezig met inloggen...',
    loginSuccess: 'Succesvol ingelogd',
    loginError: 'E-mailadres of wachtwoord is onjuist',
    invalidEmail: 'Voer een geldig e-mailadres in',
    requiredFields: 'Voer e-mailadres en wachtwoord in',
    demoAccount: 'Demo Account:',
    loginDescription: 'Log in op uw account',
    welcomeMessage: 'Welkom bij uw professionele werkruimte',
    // Registration
    register: 'Registreren',
    createAccount: 'Account Aanmaken',
    confirmPassword: 'Wachtwoord Bevestigen',
    passwordRequirements: 'Min. 8 tekens: hoofdletter, kleine letter, cijfer en symbool',
    passwordsDoNotMatch: 'Wachtwoorden komen niet overeen',
    registrationSuccess: 'Registratie succesvol',
    registrationDescription: 'Maak uw zakelijke account aan',
    alreadyHaveAccount: 'Heeft u al een account?',
    signIn: 'Inloggen',
    dontHaveAccount: 'Heeft u nog geen account?',
    creatingAccount: 'Account aanmaken...',
    registrationNote: 'Opmerking:',
    registrationNotePoints: {
      erpLinking: 'Als u een bestaand zakelijk account heeft, wordt uw e-mailadres automatisch gekoppeld',
      companyEmail: 'Gebruik uw zakelijke e-mailadres voor registratie',
      contactSupport: 'Neem contact op voor hulp bij registratie'
    },
    b2bUsers: 'Zakelijke Account Gebruikers:',
    registeredEmail: 'Geregistreerd e-mailadres',
    registeredPassword: 'Wachtwoord ingesteld tijdens registratie',
    b2bCustomerRequired: 'E-mail niet herkend. Neem contact op met verkoop voor een zakelijk account.',
    b2bVerificationError: 'Verificatiefout. Neem contact op met support.',
    // Password Reset
    passwordReset: 'Wachtwoord Resetten',
    passwordResetDescription: 'Ontvang een tijdelijk wachtwoord per e-mail',
    getTemporaryPassword: 'Tijdelijk wachtwoord ophalen',
    processing: 'Verwerken...',
    passwordResetComplete: 'Wachtwoord reset voltooid',
    temporaryPasswordGenerated: 'Tijdelijk wachtwoord is gegenereerd',
    temporaryPassword: 'Tijdelijk Wachtwoord',
    backToLogin: 'Terug naar inloggen',
    securityNotice: 'Veiligheidsmelding:',
    securityNotePoints: {
      keepSecret: 'Houd dit wachtwoord geheim',
      changeAfterLogin: 'Wijzig na inloggen',
      expires24Hours: 'Geldig voor 24 uur'
    },
    resetNote: 'Opmerking:',
    resetNotePoints: {
      registeredEmail: 'Voer uw geregistreerde e-mailadres in',
      passwordDisplayed: 'Het tijdelijke wachtwoord wordt op het scherm weergegeven',
      changeRequired: 'Wachtwoordwijziging is vereist na inloggen'
    },
    copied: 'Gekopieerd',
    copySuccessMessage: 'Tijdelijk wachtwoord gekopieerd naar klembord.',
    forgotPassword: 'Wachtwoord vergeten?',
    // Password Reset Email Request
    sendResetLink: 'Reset Link Versturen',
    sendingEmail: 'E-mail versturen...',
    emailSent: 'E-mail Verstuurd',
    emailSentMessage: 'Als dit e-mailadres bestaat in ons systeem, ontvangt u binnenkort een wachtwoord reset link.',
    emailNotSent: 'E-mail niet verstuurd',
    emailSentInfo: 'Controleer uw inbox en spam folder',
    checkEmail: 'E-mail Controleren',
    emailInstructions: 'Wachtwoord reset instructies zijn verstuurd',
    nextSteps: 'Volgende Stappen:',
    nextStepsList: {
      checkInbox: 'Controleer uw inbox en spam folder',
      clickLink: 'Klik op de reset link in de e-mail',
      linkExpires: 'De link verloopt na 24 uur',
      contactSupport: 'Neem contact op met de klantenservice als u de e-mail niet ontvangt',
      rateLimitInfo: 'Beperkt tot 3 verzoeken per uur'
    },
    // Password Reset Completion
    resetLinkSent: 'Reset Link Verstuurd',
    resetSuccess: 'Wachtwoord Succesvol Gereset',
    passwordUpdated: 'Wachtwoord Bijgewerkt',
    passwordUpdateMessage: 'Uw wachtwoord is succesvol bijgewerkt. U kunt nu inloggen met uw nieuwe wachtwoord.',
    loginWithNewPassword: 'Inloggen met Nieuw Wachtwoord',
    // Reset Token Page
    resetToken: 'Wachtwoord Resetten',
    invalidToken: 'Ongeldige reset token',
    expiredToken: 'Reset token is verlopen',
    tokenValid: 'Reset token is geldig',
    newPassword: 'Nieuw Wachtwoord',
    confirmNewPassword: 'Nieuw Wachtwoord Bevestigen',
    updatePassword: 'Wachtwoord Bijwerken',
    updatingPassword: 'Wachtwoord bijwerken...',
    passwordMismatch: 'Wachtwoorden komen niet overeen',
    resetInstructions: 'Voer uw nieuwe wachtwoord in om de reset te voltooien',
  },
  accountInfo: {
    title: 'Accountinformatie',
    loading: 'Accountinformatie laden...',
    error: 'Fout',
    errorMessage: 'Accountinformatie ophalen mislukt',
    back: 'Terug',
    basicInfo: 'Basisinformatie',
    name: 'Naam',
    email: 'E-mailadres',
    contactId: 'Knitido Klant-ID',
    contactNumber: 'Contactnummer',
    noInfo: 'Geen informatie',
    companyInfo: 'Bedrijfsinformatie',
    company: 'Bedrijfsnaam',
    position: 'Functie',
    vatId: 'BTW-nummer',
    billingAddress: 'Factuuradres',
    deliveryAddress: 'Afleveradres',
    addressInfo: 'Adresinformatie',
    billingDescription: 'Adres voor facturen en contractdocumenten',
    deliveryDescription: 'Standaard afleveradres voor productverzendingen',
    sameAsBilling: '※ Zelfde als factuuradres',
    sameAsDelivery: '※ Zelfde als afleveradres',
    companyName: 'Bedrijfsnaam',
    contactPerson: 'Contactpersoon',
    address: 'Adres',
    phoneNumber: 'Telefoonnummer',
    billingUsage: 'Gebruikt als bestemming voor facturen, contracten en andere belangrijke documenten',
    deliveryUsage: 'Gebruikt als standaard afleveradres voor bestelde producten',
    alsoUsedForDelivery: 'Ook gebruikt als afleverbestemming',
    accountType: 'Accounttype',
    addressId: 'Adres ID',
    // Address editing functionality
    edit: 'Bewerken',
    editDeliveryAddress: 'Afleveradres Bewerken',
    editDeliveryDescription: 'Werk uw afleveradresgegevens bij',
    newDeliveryAddress: 'Nieuw afleveradres toevoegen',
    newDeliveryDescription: 'Voer de gegevens van uw nieuwe afleveradres in',
    noDeliveryAddress: 'Geen afleveradres geconfigureerd',
    success: 'Succes',
    addressUpdated: 'Afleveradres succesvol bijgewerkt',
    updateError: 'Afleveradres bijwerken mislukt',
    requiredFields: 'Vul alle verplichte velden in',
    firstName: 'Voornaam',
    lastName: 'Achternaam',
    streetAddress: 'Straat en Huisnummer',
    streetAddress2: 'Straat en Huisnummer 2',
    city: 'Stad',
    country: 'Land',
    selectCountry: 'Selecteer land...',
    searchCountry: 'Zoek land...',
    noCountryFound: 'Geen land gevonden.',
    postalCode: 'Postcode',
    companyNamePlaceholder: 'Voer bedrijfsnaam in',
    firstNamePlaceholder: 'Voornaam',
    lastNamePlaceholder: 'Achternaam',
    streetAddressPlaceholder: 'Voer straat en huisnummer in',
    streetAddress2Placeholder: 'Appartement, suite, etc.',
    cityPlaceholder: 'Voer stad in',
    postalCodePlaceholder: 'Voer postcode in',
    billingNotEditable: 'Factuuradres kan niet worden bewerkt.',
    billingContactSupport: 'Neem contact op met de klantenservice voor wijzigingen.',
    // Multiple delivery addresses
    deliveryAddressCount: '{count} bezorgadressen',
    noDeliveryAddresses: 'Geen bezorgadressen geregistreerd',
    defaultAddress: 'Standaard',
    selectDeliveryAddress: 'Selecteer bezorgadres',
    addNewAddress: 'Nieuw adres toevoegen',
    editAddress: 'Adres bewerken',
    deleteAddress: 'Adres verwijderen',
    confirmDelete: 'Verwijdering bevestigen',
    confirmDeleteMessage: 'Weet u zeker dat u dit adres wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.',
    addressAddedSuccess: 'Bezorgadres toegevoegd',
    addressDeletedSuccess: 'Bezorgadres verwijderd',
    deleteError: 'Kan bezorgadres niet verwijderen',
    saving: 'Opslaan...',
    cancel: 'Annuleren',
    saveChanges: 'Wijzigingen opslaan',
    selectedDeliveryAddress: 'Geselecteerd bezorgadres',
  },
  dashboard: {
    title: 'Zakelijke Partner',
    subtitle: 'Productbestelsysteem',
    welcome: 'Welkom,',
    welcomeMessage: 'Welkom bij het Zakelijke Partner bestelsysteem. U kunt hier producten bestellen.',
    productCatalog: 'Productcatalogus',
    productCatalogDesc: 'Bekijk en bestel beschikbare producten',
    viewProducts: 'Producten Bekijken',
    orderHistory: 'Bestelgeschiedenis',
    orderHistoryDesc: 'Bekijk eerdere bestellingen (binnenkort beschikbaar)',
    accountSettings: 'Accountinstellingen',
    accountSettingsDesc: 'Beheer accountinformatie (binnenkort beschikbaar)',
    comingSoon: 'Binnenkort Beschikbaar',
    infoTitle: 'Over Gebruik',
    orderingInfo: 'Productbestelling',
    orderingDesc: 'Selecteer producten uit de catalogus en specificeer maat en kleur. Real-time voorraadinfo is beschikbaar.',
    supportInfo: 'Ondersteuning',
    supportDesc: 'Als u vragen heeft, neem dan contact met ons op.',
    viewOrderHistory: 'Bestelgeschiedenis Bekijken',
    viewOrders: 'Bestellingen Bekijken',
    accountInfo: 'Accountinformatie',
    accountInfoDesc: 'Bekijk uw accountgegevens',
    viewDetails: 'Details Bekijken',
    supportEmail: 'b2b-partner@knitido.de',
    supportPhone: '+49(0)30 6640 9300',
    businessHours: 'Maandag-Vrijdag 9:00 - 15:00 CET',
    bulkImportDesc: 'Importeer bestellingen uit Excel/CSV-bestanden',
    importOrders: 'Bestellingen importeren',
  },
  products: {
    title: 'Productlijst',
    subtitle: 'Zakelijke Partner',
    searchPlaceholder: 'Zoeken op productnaam of SKU...',
    productId: 'Product ID',
    addToCart: 'Toevoegen aan Winkelwagen',
    selectVariation: 'Variatie Selecteren',
    price: 'Prijs',
    priceNetNotice: 'Alle prijzen zijn nettoprijzen',
    stock: 'Voorraad',
    color: 'Kleur',
    newProducts: 'Nieuwe Producten',
    newProductBadge: 'NIEUW',
    size: 'Maat',
    quantity: 'Aantal',
    total: 'Totaal',
    cart: 'Winkelwagen',
    checkout: 'Afrekenen',
    csvMode: 'CSV Snelle Modus',
    csvInfo: 'Productgegevens opgehaald uit CSV-gegevens',
    csvUploadDate: 'CSV Upload Datum:',
    stockNote: '※ Voorraadgegevens worden opgehaald bij het selecteren van productvariaties',
    noProducts: 'Geen producten gevonden',
    noProductsDesc: 'Wijzig zoekcriteria of upload een CSV-bestand voor betere prestaties.',
    retry: 'Opnieuw proberen',
    pagination: 'items',
    variations: 'variaties',
    stockFetchError: 'Voorraad ophaal fout',
    stockFetchFailed: 'Voorraad ophalen mislukt',
    stockFetchFailedDesc: 'Kon voorraadgegevens niet ophalen. CSV-voorraad wordt weergegeven.',
    stockFetched: 'Voorraadgegevens opgehaald',
    totalStock: 'Totale voorraad',
    noStockAll: 'Alle variaties hebben nul voorraad',
    noStockData: 'Geen voorraadgegevens geretourneerd',
    stockFetchErrorDesc: 'Fout opgetreden bij het ophalen van voorraadgegevens',
    selectionError: 'Selectiefout',
    enterQuantity: 'Voer aantal in',
    addedToCart: 'Toegevoegd aan winkelwagen',
    typesAdded: ' producttypen toegevoegd',
    addToCartError: 'Fout bij toevoegen aan winkelwagen',
    addToCartErrorDesc: 'Probeer het opnieuw',
    loadingStock: 'Voorraadgegevens laden',
    csvDataInfo: 'CSV-gegevens weergeven (niet werkelijke voorraadniveaus)',
    filterByCategory: 'Filteren op categorie',
    allProducts: 'Alle producten',
    applyFilters: 'Filters toepassen',
    clearFilters: 'Filters wissen',
    filters: 'Filters',
    clearAll: 'Alles wissen',
    invalidDataFormat: 'Productgegevensformat is ongeldig',
    loadFailed: 'Productgegevens laden mislukt',
    csvUploadComplete: 'CSV-upload voltooid',
    csvLoadedDesc: ' productgegevens geladen. Voorraadgegevens worden opgehaald bij het selecteren van producten.',
    searchTitle: 'Product Zoeken',
    loadingProducts: 'Productgegevens laden',
    noProductsCsv: 'Geen producten gevonden in CSV-gegevens. Wijzig zoekcriteria.',
    paginationDisplay: ' weergegeven',
    previous: 'Vorige',
    next: 'Volgende',
    selectionSummary: 'Selectie Overzicht',
    selectedQuantity: 'Geselecteerd Aantal',
    items: ' items',
    viewDetails: 'Details Bekijken',
    productImage: 'Productafbeelding',
    correspondingVariations: 'Overeenkomende Variaties',
    clickToEnlarge: 'Klik om te vergroten',
    productIdLabel: 'Product ID',
    colorLabel: 'Kleur',
  },
  productDetail: {
    title: 'Productdetails',
    backToProducts: 'Terug naar Producten',
    productNotFound: 'Product Niet Gevonden',
    productNotFoundDesc: 'Het opgegeven product bestaat niet of is verwijderd.',
    loading: 'Product laden...',
    imageLoadError: 'Afbeeldingen laden mislukt',
    noImages: 'Geen afbeeldingen beschikbaar',
    productDescription: 'Productbeschrijving',
    colors: 'Kleuren',
    sizes: 'Maten',
    colorCount: 'kleuren',
    sizeCount: 'maten',
    variationCount: 'variaties',
    selectVariation: 'Variaties Selecteren',
    descriptionLanguageNote: '※ Productbeschrijvingen zijn alleen beschikbaar in het Engels of Duits',
  },
  colors: {
    schwarz: 'Zwart',
    weiß: 'Wit',
    grau: 'Grijs',
    rot: 'Rood',
    blau: 'Blauw',
    grün: 'Groen',
    gelb: 'Geel',
    rosa: 'Roze',
    lila: 'Paars',
    braun: 'Bruin',
    orange: 'Oranje',
    beige: 'Beige',
    navy: 'Marineblauw',
    dunkelblau: 'Donkerblauw',
    hellblau: 'Lichtblauw',
    dunkelgrau: 'Donkergrijs',
    hellgrau: 'Lichtgrijs',
    bordeaux: 'Bordeaux',
    türkis: 'Turkoois',
    khaki: 'Kaki',
    mint: 'Mint',
    violett: 'Violet',
    anthrazit: 'Antraciet',
    blaugrau: 'Blauwgrijs',
    burgunderrot: 'Bordeauxrood',
    elfenbein: 'Ivoor',
    karminrot: 'Karmijnrood',
    neongrün: 'Neongroen',
    gelbgrün: 'Geelgroen',
    pistazie: 'Pistache',
    // Engelse kleurnamen (gebruikt in Product ID 237, enz.)
    blue: 'Blauw',
    ivory: 'Ivoor',
    green: 'Groen',
    gold: 'Goud',
    red: 'Rood',
  },
  categories: {
    category_21: 'Accessoires',
    category_23: 'Basissokken',
    category_24: 'Aanbiedingen',
    category_29: 'B2B'
  },
  checkout: {
    title: 'Afrekenen',
    cartReview: 'Bestelling Controleren',
    orderSummary: 'Bestelling Overzicht',
    shippingInfo: 'Verzendgegevens',
    billingInfo: 'Factuurgegevens',
    orderNotes: 'Bestelling Opmerkingen',
    orderNotesPlaceholder: 'Speciale verzoeken of opmerkingen...',
    contactPerson: 'Contactpersoon',
    phoneNumber: 'Telefoonnummer',
    email: 'E-mailadres',
    company: 'Bedrijf',
    address: 'Adres',
    city: 'Stad',
    postalCode: 'Postcode',
    country: 'Land',
    deliveryDate: 'Leveringsdatum',
    urgentDelivery: 'Express Levering (3-5 werkdagen)',
    standardDelivery: 'Standaard Levering (7-10 werkdagen)',
    placeOrder: 'Bestelling Plaatsen',
    backToCart: 'Terug naar Productselectie',
    requiredField: 'Verplicht veld',
    orderTotal: 'Bestelling Totaal',
    subtotal: 'Subtotaal',
    priceNetNotice: 'Alle prijzen zijn nettoprijzen',
    stockReservationNotice: 'Voorraadreservering wordt gemaakt na bestelbevestiging.',
    stockCheckError: 'Voorraad Controle Fout',
    stockCheckErrorDesc: 'Fout opgetreden tijdens voorraadcontrole. Probeer opnieuw.',
    shipping: 'Verzending',
    shippingCost: 'Verzendkosten',
    tax: 'BTW',
    orderSuccess: 'Bestelling Succesvol',
    orderSuccessMessage: 'Uw bestelling is succesvol ingediend. Bestelnummer: {orderNumber}',
    orderNumber: 'Bestelnummer',
    thankYou: 'Dank u voor uw bestelling!',
    orderConfirmation: 'Uw bestelling is succesvol ingediend.',
    orderProcessing: 'Na controle door ons team sturen wij u een bestelbevestiging via e-mail.',
    orderProcessingMessage: 'Uw bestelling is succesvol ingediend. Na controle door ons team sturen wij u een bestelbevestiging via e-mail.',
    continueShopping: 'Verder Winkelen',
    emptyCart: 'Uw winkelwagen is leeg',
    emptyCartMessage: 'Voeg producten toe aan uw winkelwagen om door te gaan',
    stockWarning: 'Voorraad Waarschuwing',
    stockWarningDesc: 'Sommige items hebben onvoldoende voorraad. Pas aantallen aan.',
    stockError: 'Voorraad Fout',
    stockErrorDesc: 'Er zijn items met onvoldoende voorraad. Pas aantallen aan.',
    refreshStock: 'Voorraad Vernieuwen',
    stockUpdated: 'Voorraad Bijgewerkt',
    stockUpdatedDesc: 'Voorraad is bijgewerkt - {changed} items gewijzigd',
    stockCheckDesc: 'Vergelijkingsresultaten met inventaris worden weergegeven',
    stockOk: 'Voorraad OK',
    stockShortage: 'Voorraadtekort',
    requestedQty: 'Gevraagd Aantal',
    currentStock: 'Huidige Voorraad',
    stockShortageMsg: 'Onvoldoende voorraad. Pas het aantal aan.',
    stockIssueWarning: 'Bestelling kan niet worden bevestigd vanwege voorraadproblemen.',
    stockDataMissing: 'Voorraadgegevens worden opgehaald. Een moment geduld.',
    outOfStock: 'Niet op voorraad.',
    maxAvailable: 'Maximum',
    autoRestored: 'Winkelwagen hersteld',
    autoRestoredDesc: 'Artikelen uit uw laatste sessie zijn hersteld',
    maxQuantityReached: 'Maximum voorraadhoeveelheid bereikt.',
    // ERP Contact Search
    contactSearch: 'Klant Contact Zoeken',
    contactSearchDesc: 'Voer het e-mailadres van de besteller in om contactgegevens op te halen',
    emailAddress: 'E-mailadres',
    searchButton: 'Zoeken',
    searching: 'Zoeken',
    contactFound: 'Contact Gevonden',
    contactNotFound: 'Contact Niet Gevonden',
    contactId: 'Knitido Klant-ID',
    companyName: 'Bedrijf',
    contactPersonLabel: 'Contactpersoon',
    addressesFound: 'Adressen Gevonden',
    addressType: 'Type',
    addressBilling: 'Factuuradres',
    addressDelivery: 'Afleveradres',
    vatSourceCompany: 'Bedrijfsinfo',
    vatSourceBilling: 'Factuur',
    vatSourceDelivery: 'Levering',
    addressOther: 'Ander',
    addressDetails: 'Adres',
    loadingAddresses: 'Adresgegevens laden...',
    addressRetrieved: 'Adresgegevens opgehaald',
    addressNotFound: 'Adresgegevens niet gevonden',
    addressNotFoundDesc: 'Geen adresgegevens geregistreerd. Voer handmatig in.',
    addressError: 'Adres Ophaal Fout',
    addressErrorDesc: 'Adresgegevens ophalen mislukt.',
    contactNotConfirmed: 'Klant Contact Niet Bevestigd',
    contactNotConfirmedDesc: 'Voer een e-mailadres in en zoek naar het contact.',
    searchContact: 'Contact Zoeken',
    inputError: 'Invoer Fout',
    inputErrorDesc: 'Verzendgegevens zijn incompleet. Controleer.',
    processing: 'Verwerken...',
    erpContactSearch: 'Klant Contact Zoeken',
    contactSearchError: 'E-mailadres komt niet overeen met een geregistreerd contact.',
    // Product Images Toggle
    showProductImages: 'Productafbeeldingen Tonen',
    showProductImagesDesc: 'Toon productafbeeldingen voor beter overzicht (kan laadtijd verhogen)',
    // System Registration Info
    systemRegistrationInfo: 'Uw Klantgegevens',
    editShippingAddress: 'Afleveradres Bewerken',
    systemRegistrationInfoDesc: 'Uw geregistreerde bedrijfsgegevens. Neem contact op met uw vertegenwoordiger als u factuuradresgegevens wilt bijwerken.',
    // Order Summary
    regularPrice: 'Reguliere groothandelsprijs',
    offeredPrice: 'Aangeboden prijs',
    discount: 'Korting',
    b2bCustomer: 'B2B-klant',
    pattern: 'Patroon',
    specialPriceApplied: 'Speciale prijs toegepast',
    customerClassification: 'Klantclassificatie',
    paymentCondition: 'Betalingsvoorwaarden',
    invoice: 'Factuur (NET 30)',
    prepayment: 'Vooruitbetaling',
    paymentMethod: 'Betalingsmethode',
    invoicePayment: 'Betaling per factuur',
    estimatedSubtotal: 'Geschat Subtotaal',
    estimatedTotal: 'Geschat Totaal',
    orderSummaryDisclaimer: 'De hier getoonde prijzen zijn schattingen. Zodra wij uw bestelling ontvangen, zullen wij deze controleren en u een bindende bestelbevestiging sturen met definitieve prijzen, verzendkosten en belastingen via e-mail.',
    searchError: 'Zoek Fout',
    searchErrorDesc: 'Een fout trad op tijdens contact zoeken.',
    confirmDeleteItem: 'Item Verwijderen',
    itemDeleted: 'Item verwijderd',
    confirmDeleteItemDesc: 'Weet u zeker dat u het volgende item uit uw winkelwagen wilt verwijderen?',
    deleteConfirm: 'Verwijderen',
    contactNotes: 'Contact Opmerkingen',
    contactNotesDesc: 'Heeft u vragen of speciale verzoeken? Laat het ons weten (optioneel)',
    contactNotesLabel: 'Bericht',
    contactNotesPlaceholder: 'bijv.: Productvragen, speciale vereisten, etc.',
    characters: 'tekens',
    contactIdLabel: 'Knitido Klant-ID',
    companyLabel: 'Bedrijf',
    personLabel: 'Contactpersoon',
    emailLabel: 'E-mail',
    addressTypeLabel: 'Type',
    destinationLabel: 'Bestemming',
    // Shipping Form
    shippingTitle: 'Verzendgegevens',
    shippingDesc: 'Voer het afleveradres voor de producten in',
    companyRequired: 'Bedrijf *',
    contactPersonRequired: 'Contactpersoon *',
    emailRequired: 'E-mailadres *',
    phoneRequired: 'Telefoonnummer *',
    addressRequired: 'Adres 1 *',
    address2: 'Adres 2 (Gebouw/Kamer)',
    postalCodeRequired: 'Postcode *',
    cityRequired: 'Stad *',
    countryRequired: 'Land *',
    selectCountry: 'Selecteer Land',
    shippingMethodRequired: 'Verzendmethode *',
    selectShippingMethod: 'Selecteer Verzendmethode',
    urgentDeliveryOption: 'Express Levering (extra kosten)',
    deliveryNotes: 'Levering Opmerkingen',
    deliveryNotesPlaceholder: 'Voer leveringstijd voorkeuren of andere verzoeken in',
    standardShipping: 'Standaard Verzending (3-5 werkdagen)',
    expressShipping: 'Express Verzending (1-2 werkdagen)',
    overnightShipping: 'Overnight Verzending',
    germany: 'Duitsland',
    austria: 'Oostenrijk',
    switzerland: 'Zwitserland',
    japan: 'Japan',
    shippingAddressLabel: 'Afleveradres',
    changeDeliveryAddress: 'Afleveradres wijzigen',
    selectDeliveryAddress: 'Afleveradres selecteren',
    // Shipping Cost Details
    freeShipping: 'Gratis verzending',
    shippingError: 'Fout',
    shippingZone: 'Verzendzone',
    remainingForFreeShipping: '{amount} meer voor gratis verzending',
    moreForFreeShipping: 'voor gratis verzending',
    freeShippingProgress: 'Gratis verzending vanaf',
    andAboveFreeShipping: 'en hoger voor gratis verzending',
    freeShippingAchieved: 'Gratis verzending toegepast',
    threshold: 'en hoger',
    nextShippingTier: 'Volgende verzendkorting',
    moreForDiscount: 'meer voor',
    shippingSavings: 'besparing op verzending',
    orderAmountThreshold: 'en hoger voor',
    specialRegionNotice: 'Speciale verzendregio toegepast',
    defaultShippingApplied: 'Standaard verzendtarieven toegepast',
    requestedQuantity: 'Aangevraagde hoeveelheid',
    availableQuantity: 'Beschikbare hoeveelheid',
    orderSubmitError: 'Bestelfout',
    orderSubmitErrorDesc: 'Bestelling kon niet worden ingediend',
    upload: {
      title: 'Excel/CSV bestelling importeren',
      description: 'Upload een Excel- of CSV-bestand met uw bestelgegevens',
      dragDropOrClick: 'Sleep het bestand hierheen of klik om te selecteren',
      dropHere: 'Laat het bestand hier vallen',
      supportedFormats: 'Ondersteunde formaten: Excel (.xlsx, .xls) en CSV (.csv)',
      maxSize: 'Maximale bestandsgrootte: {size} MB',
      processFile: 'Bestand verwerken',
      processing: 'Bestand verwerken...',
      ready: 'Bestand klaar voor preview',
      readyDescription: 'Uw bestand is succesvol verwerkt en klaar voor controle.',
      preview: 'Preview tonen',
      errors: {
        fileTooLarge: 'Bestand is te groot. Maximale grootte: {size} MB',
        invalidFileType: 'Ongeldig bestandstype. Upload een Excel- of CSV-bestand',
        uploadFailed: 'Fout bij uploaden van bestand',
      },
    },
    // Loading messages
    loadingPage: 'Pagina laden...',
    loadingStock: 'Productvoorraad controleren...',
    loadingAccount: 'Accountgegevens laden...',
    loadingError: 'Een fout is opgetreden...',
    loadingData: 'Gegevens laden',
    // Toast messages
    addressRetrievedTitle: 'Adresgegevens opgehaald',
    addressSetAsDelivery: ' adres ingesteld als leverbestemming.',
    contactFoundDesc: ' werd herkend.'
  },
  orderHistory: {
    title: 'Bestelgeschiedenis',
    searchPlaceholder: 'Zoeken op bestelnummer of SKU...',
    noOrders: 'Geen bestellingen gevonden',
    noOrdersFound: 'Geen overeenkomende bestellingen gevonden',
    startShopping: 'Producten Bekijken',
    orderItems: 'Bestelling Items',
    viewDetails: 'Details',
    reorder: 'Opnieuw Bestellen',
    orderDate: 'Besteldatum',
    orderStatus: 'Status',
    orderTotal: 'Bestelling Totaal',
    // Status translations
    statusPending: 'Betaling in Behandeling',
    statusProcessing: 'Verwerken',
    statusConfirmed: 'Bevestigd',
    statusShipped: 'Verzonden',
    statusDelivered: 'Geleverd',
    statusCancelled: 'Geannuleerd',
    statusReturned: 'Geretourneerd',
    statusRefunded: 'Terugbetaald',
    statusWarranty: 'Garantie',
    statusExchanged: 'Uitgewisseld',
    statusRepair: 'Reparatie',
    statusUnknown: 'Onbekend',
    statusIncomplete: 'Incompleet',
    statusWaitingPayment: 'Wachten op Betaling',
    statusInPreparation: 'In Voorbereiding',
    statusClearedShipping: 'Klaar voor Verzending',
    statusBeingShipped: 'Wordt Verzonden',
    statusOutgoingBooked: 'Uitgaand Geboekt',
    statusReturn: 'Retour',
    // Additional UI elements
    itemCount: 'items',
    itemCountSingular: 'item',
    refreshButton: 'Vernieuwen',
    errorFetchingOrders: 'Bestelgeschiedenis ophalen mislukt',
    // Payment status features
    paymentStatus: 'Betalingsstatus',
    markAsPaid: 'Markeren als betaald',
    unmarkAsPaid: 'Betaald-markering verwijderen',
    paidOn: 'Betaald op',
    paymentMarked: 'Betaald',
    notPaid: 'Niet betaald',
    paymentMarkedSuccess: 'Gemarkeerd als betaald',
    paymentUnmarkedSuccess: 'Betaald-markering verwijderd',
    paymentUpdateError: 'Fout bij het bijwerken van de betalingsstatus',
    // Payment date dialog
    paymentDateTitle: 'Betalingsinformatie invoeren',
    paymentDateDescription: 'Voer betalingsinformatie in voor bestelling {orderNumber}',
    paymentDateLabel: 'Betaaldatum',
    selectDate: 'Selecteer datum',
    paymentDateHelp: 'Selecteer de datum van de bankoverschrijving',
    paymentMethodLabel: 'Betaalmethode',
    bankTransfer: 'Bankoverschrijving',
    invoice: 'Factuur',
    otherPayment: 'Anders',
    paymentReferenceLabel: 'Betalingsreferentie',
    paymentReferencePlaceholder: 'bijv. Overschrijving van 01-01-2024',
    paymentReferenceHelp: 'Voer informatie in voor reconciliatie',
    notesLabel: 'Notities',
    notesPlaceholder: 'Aanvullende informatie over de betaling',
    // Filter options
    filterByPaymentStatus: 'Filteren op betalingsstatus',
    allOrders: 'Alle bestellingen',
    paidOrders: 'Betaald',
    unpaidOrders: 'Onbetaald',
    // Sorting options
    sortBy: 'Sorteren op',
    sortByDate: 'Besteldatum',
    sortByPaymentDate: 'Betaaldatum',
    sortByAmount: 'Bedrag',
    sortByStatus: 'Status',
  },
  orderDetails: {
    title: 'Bestelling Details',
    notFound: 'Bestelling niet gevonden',
    backToHistory: 'Terug naar Bestelgeschiedenis',
    orderDate: 'Besteldatum',
    orderItems: 'Bestelling Items',
    deliveryStatus: 'Leveringsstatus',
    estimatedDelivery: 'Geschatte Levering',
    deliveredOn: 'Geleverd op',
    downloadInvoice: 'Factuur Downloaden',
    statusDelivered: 'Geleverd',
    statusShipped: 'Verzonden',
    statusConfirmed: 'Bevestigd',
    statusCancelled: 'Geannuleerd',
    errorFetchingDetails: 'Bestelling details ophalen mislukt',
  },
  company: {
    name: 'Zakelijke Partner',
    tagline: 'Zakelijke Partner Systeem',
    copyright: '© 2025 Zakelijke Partner Systeem. Alle rechten voorbehouden.',
  },
  footer: {
    phone: 'Telefoon',
    email: 'E-mail',
    countries: {
      DE: 'Duitsland',
      AT: 'Oostenrijk',
      CH: 'Zwitserland',
      FR: 'Frankrijk',
      IT: 'Italië',
      ES: 'Spanje',
      NL: 'Nederland',
      BE: 'België',
      PL: 'Polen',
      SE: 'Zweden',
      NO: 'Noorwegen',
      FI: 'Finland',
      DK: 'Denemarken',
      LT: 'Litouwen',
      LV: 'Letland',
      EE: 'Estland',
    },
  },
  cart: {
    newCart: 'Nieuwe Winkelwagen',
    currentCart: 'Huidige Winkelwagen',
    modified: 'gewijzigd',
    lastSaved: 'Laatst opgeslagen',
    unsavedChanges: 'niet-opgeslagen wijzigingen',
    saveCart: 'Winkelwagen Opslaan',
    loadCart: 'Winkelwagen Laden',
    deleteCart: 'Winkelwagen Verwijderen',
    startNewCart: 'Nieuwe Winkelwagen Starten',
    savedCarts: 'Opgeslagen Winkelwagens',
    cartSaved: 'Winkelwagen opgeslagen',
    cartDeleted: 'Winkelwagen verwijderd',
    confirmDeleteCart: 'Winkelwagen verwijderen?\n\nDeze actie kan niet ongedaan worden gemaakt.',
    confirmSwitchCart: 'De huidige winkelwagen heeft niet-opgeslagen wijzigingen.\n\nEen andere winkelwagen laden zal de huidige wijzigingen verloren laten gaan.\n\nDoorgaan?',
    confirmSwitchCartTitle: 'Winkelwagen wisselen',
    confirmNewCart: 'De huidige winkelwagen heeft niet-opgeslagen wijzigingen.\n\nEen nieuwe winkelwagen starten zal de huidige wijzigingen verloren laten gaan.\n\nDoorgaan?',
    confirmNewCartTitle: 'Nieuwe winkelwagen starten',
    confirmClearCart: 'Winkelwagen leegmaken?\n\n{count} items worden verwijderd.\n\nDeze actie kan niet ongedaan worden gemaakt.',
    confirmClearCartTitle: 'Winkelwagen leegmaken',
    autoSaved: 'Automatisch opgeslagen',
    itemsWillBeRemoved: 'items worden verwijderd',
    changesWillBeLost: 'wijzigingen gaan verloren',
    continueQuestion: 'Doorgaan?',
    cartStatus: 'Winkelwagen Status',
    cartName: 'Winkelwagen Naam',
    cartNamePlaceholder: 'bijv.: Eind van maand bestelling',
    cartNameRequired: 'Voer een winkelwagen naam in',
    saveCartDescription: 'Geef de huidige winkelwagen een naam en sla deze op. U kunt deze later laden.',
    cancelCart: 'Winkelwagen Annuleren',
    proceedToCheckout: 'Doorgaan naar afrekenen',
    emptyCart: 'Winkelwagen is leeg',
    erpDown: 'Het bestelsysteem is uitgevallen. Probeer het later opnieuw.',
    erpDegraded: 'Het systeem is momenteel onstabiel. Bestellingen kunnen mislukken.',
    erpDownSaveHint: 'Sla uw winkelwagen op en bestel wanneer het systeem is hersteld.',
    erpSaveCart: 'Winkelwagen opslaan',
  },
  nav: {
    dashboard: 'Dashboard',
    products: 'Producten',
    orderHistory: 'Bestelgeschiedenis',
    account: 'Account Info',
    bulkImport: 'Bulk Import',
  },
  settings: {
    selectLanguage: 'Selecteer een Taal',
    languagePreferenceSaved: 'Uw voorkeur wordt opgeslagen in uw account voor toekomstige bezoeken.',
  },
  reorder: {
    allItemsAdded: '{count} artikelen toegevoegd aan winkelwagen',
    partialSuccess: '{added} artikelen toegevoegd. {failed} artikelen konden niet worden toegevoegd',
    allItemsFailed: 'Kon artikelen niet toevoegen aan winkelwagen',
    error: 'Er is een fout opgetreden bij het opnieuw bestellen',
    itemDiscontinued: '{name} ({color}/{size}) is niet meer leverbaar',
    itemOutOfStock: '{name} ({color}/{size}) is uitverkocht',
    partialStock: '{name} ({color}/{size}) slechts {available} beschikbaar',
    confirmReorder: 'Bevestig herbestelling',
    confirmReorderMessage: 'Artikelen van deze bestelling toevoegen aan uw winkelwagen?',
    addingToCart: 'Toevoegen aan winkelwagen...',
    checkingStock: 'Voorraad controleren...',
    checkoutTitle: 'Items toegevoegd aan winkelwagen',
    checkoutDescription: '{count} items toegevoegd aan uw winkelwagen. Wilt u doorgaan naar afrekenen?',
  },
  bulkImport: {
    instructions: 'Hoe bestellingen importeren',
    step1: 'Download het bestelsjabloonbestand',
    step2: 'Vul uw bestelgegevens in met SKU en hoeveelheid',
    step3: 'Sla op als Excel (.xlsx) of CSV-bestand',
    step4: 'Upload het bestand met het onderstaande formulier',
    step5: 'Bekijk en bevestig uw bestelling',
    downloadTemplate: 'Sjabloon downloaden',
    formatGuide: 'Bestandsformaat handleiding',
    requiredColumns: 'Verplichte kolommen',
    skuDescription: 'Product SKU-code',
    quantityDescription: 'Bestelhoeveelheid (positief geheel getal)',
    optionalColumns: 'Optionele kolommen',
    notesDescription: 'Interne notities (bijv. PO-nummer, referenties) - alleen voor uw eigen administratie',
    formatNote: 'De eerste rij moet kolomkoppen bevatten. Gegevens beginnen vanaf de tweede rij.',
    parseSuccess: 'Succesvol {count} items uit het bestand verwerkt',
    parseError: 'Verwerkingsfout',
    validationError: 'Validatiefouten',
    validationErrorGuidance: 'Klik op de knop “{showPreviewButton}” om de details te bekijken.',
    warnings: 'Waarschuwingen',
    itemsParsed: 'Succesvol {count} items verwerkt:',
    andMore: '...en nog {count} items',
    validationSummary: 'Validatiesamenvatting',
    duplicateSKUs: 'Dubbele SKUs gevonden',
    skuFormat: 'SKU mag alleen letters, cijfers en streepjes bevatten',
    quantityRange: 'Hoeveelheid moet tussen 1 en 9999 zijn',
    maxRows: 'Maximaal 1000 rijen toegestaan',
    rowsSkipped: '{count} rijen zijn overgeslagen vanwege fouten',
    previewTitle: 'Bestelvoorbeeld',
    previewDescription: 'Bekijk en bewerk uw bestelgegevens voordat u doorgaat',
    proceedToCart: 'Toevoegen aan winkelwagen',
    // Bestandsverwerkingsberichten
    fileEmpty: 'Bestand is leeg of bevat geen gegevens',
    fileTooManyRows: 'Bestand bevat te veel rijen ({current}). Maximum toegestaan: {max}',
    invalidRowFormat: 'Ongeldig rijformaat',
    missingColumns: 'Verplichte kolommen ontbreken (SKU en Hoeveelheid)',
    missingSku: 'Ontbrekende SKU',
    invalidSkuFormat: 'Ongeldig SKU-formaat: "{sku}" (moet overeenkomen met patroon: {pattern})',
    skuTooLong: 'SKU te lang: "{sku}" (maximaal 50 tekens)',
    invalidQuantity: 'Ongeldige hoeveelheid: "{quantity}" is geen getal',
    quantityTooLow: 'Hoeveelheid te laag: {quantity} (minimum: {min})',
    quantityTooHigh: 'Hoeveelheid te hoog: {quantity} (maximum: {max})',
    notesRequired: 'Notitieveld is verplicht',
    noValidData: 'Geen geldige gegevens gevonden. Controleer uw bestandsformaat.',
    row: 'Rij {row}: {errors}',
    rowErrors: '...en nog {count} fouten',
    duplicateSkuInRows: 'Dubbele SKU "{sku}" gevonden in rijen: {rows}',
    quantityExceedsMax: 'Rij {row}: Hoeveelheid {quantity} overschrijdt maximum toegestaan ({max})',
    quantityBelowMin: 'Rij {row}: Hoeveelheid {quantity} is onder minimum vereist ({min})',
    // Validatieberichten
    unsupportedFileFormat: 'Niet-ondersteund bestandsformaat. Upload een CSV- of Excel-bestand.',
    csvParsingErrors: 'CSV-verwerkingsfouten opgetreden',
    failedToParseFile: 'Kan bestand niet verwerken',
    failedToParseExcel: 'Kan Excel-bestand niet verwerken',
    failedToReadFile: 'Kan bestand niet lezen',
    unknownError: 'Onbekende fout opgetreden',
    totalRows: 'Totaal rijen',
    valid: 'Geldig',
    invalid: 'Ongeldig',
    skipped: 'Overgeslagen',
    // SKU-validatie
    skuValidationError: 'SKU-validatiefout',
    skuValidationFailed: 'SKU-validatie mislukt. U kunt nog steeds doorgaan, maar sommige items zijn mogelijk niet beschikbaar.',
    skuNotFound: 'SKU niet gevonden in database',
    skusNotFound: '{count} SKUs niet gevonden in database',
    itemsHaveInsufficientStock: '{count} artikelen hebben onvoldoende voorraad',
    validatingSKUs: 'Artikelen controleren...',
    unvalidatedChanges: 'U heeft niet-gevalideerde wijzigingen. Valideer opnieuw voordat u aan winkelwagen toevoegt.',
    revalidate: 'Opnieuw valideren',
    validating: 'Valideren...',
    validationSuccess: 'Alle artikelen zijn geldig',
    validationComplete: 'Validatie voltooid',
    validationResultSummary: '{errors} fouten, {warnings} waarschuwingen gevonden',
    // Tabelkoppen
    actions: 'Acties',
    notes: 'Notities',
    // Statusfilter
    all: 'Alle',
    hasErrors: 'Met fouten',
    // Selectieoverzicht
    selected: 'geselecteerd',
    errors: 'fouten',
    // Paginering
    page: 'Pagina {current} van {total}',
    previous: 'Vorige',
    next: 'Volgende',
    noResults: 'Geen resultaten.',
    // Winkelwagenintegratie
    noValidItems: 'Geen geldige items',
    allItemsHaveErrors: 'Alle items hebben validatiefouten. Los deze op voordat u doorgaat.',
    dataLoadingError: 'Gegevens laden fout',
    failedToLoadProductData: 'Kan productgegevens niet laden. Probeer het opnieuw.',
    itemsAddedToCart: '{count} items toegevoegd aan winkelwagen',
    itemsAddedMessage: '{count} items toegevoegd aan winkelwagen',
    someSkusNotFound: '{count} SKUs konden niet worden gevonden.',
    noItemsAdded: 'Geen items toegevoegd',
    couldNotFindProducts: 'Kon geen producten vinden die overeenkomen met de SKUs.',
    errorAddingToCart: 'Fout',
    failedToAddToCart: 'Kan items niet toevoegen aan winkelwagen. Probeer het opnieuw.',
    addingToCart: 'Toevoegen aan winkelwagen...',
    // Bestandsinformatie
    fileSelected: '{name} geselecteerd voor verwerking',
    fileSize: '{size} bytes',
    fileSizeKB: '{size} KB',
    fileSizeMB: '{size} MB',
    // Sjabloon downloaden
    templateDownload: 'Sjabloon downloaden',
    templateWillBeImplemented: 'Sjabloon downloaden wordt geïmplementeerd in Fase 7',
    // Aanvullende validatie
    validationFailed: 'Validatie mislukt',
    // Sjabloon downloaden
    templateDownloaded: 'Sjabloon succesvol gedownload',
    templateDownloadError: 'Fout bij downloaden sjabloon',
    downloadExcelTemplate: 'Excel-sjabloon downloaden',
    downloadCsvTemplate: 'CSV-sjabloon downloaden',
    // Sjablooninhoud
    sheetName: 'Bulkbestelling',
    instructionsSheetName: 'Instructies',
    columnDescriptions: 'Kolombeschrijvingen:',
    columnHeader: 'Kolom',
    columnRequired: 'Verplicht',
    columnOptional: 'Optioneel',
    columnDescription: 'Beschrijving',
    templateNotes: 'Opmerkingen:',
    templateNote1: 'De eerste rij moet kolomkoppen bevatten precies zoals getoond',
    templateNote2: 'Gegevens beginnen vanaf rij 2',
    templateNote3: 'SKU moet overeenkomen met bestaande productcodes in het systeem',
    templateNote4: 'Hoeveelheid moet een positief geheel getal tussen 1 en 9999 zijn',
    templateNote5: 'Maximaal 1000 rijen toegestaan per bestand',
    templateNote6: 'Opslaan als .xlsx of .csv formaat',
    stockAvailabilityWarning: 'De werkelijke voorraadbeschikbaarheid wordt gecontroleerd op de volgende checkout-pagina.',
    outOfStock: 'Uit voorraad',
    insufficientStock: 'Onvoldoende voorraad: {available} beschikbaar, {requested} aangevraagd',
  },
  orderExport: {
    export: 'Bestelling exporteren',
    exportOrder: 'Bestelgegevens exporteren',
    exportAsCSV: 'Exporteren als CSV',
    exportAsExcel: 'Exporteren als Excel',
    exportForReorder: 'Exporteren voor bulkimport',
    detailed: 'Volledige details',
    simpleFormat: 'Importformaat',
  },
};